import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const POS = () => {
  const [ticket, setTicket] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [basket, setBasket] = useState([]);
  const [categoriesWithProducts, setCategoriesWithProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tid, settID] = useState();
  const [pid, setpID] = useState();

  const surl = process.env.REACT_APP_SRV;

  const location = useLocation();

  const getCurrentTimeAndDate = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    return `${hours}:${minutes} ${day}-${month}-${year}`;
  };

  const handlePlaceOrder = async () => {
    if (basket.length === 0) return;

    const token = sessionStorage.getItem('token');
    const orderData = {
        terminal: tid,
        place: pid,
        products: basket.map(item => ({
            product: item.product._id,
            quantity: item.quantity,
        })),
        orderType: 'dine-in',
        totalPrice: basket
            .reduce((total, item) => total + item.product.price * item.quantity, 0)
            .toFixed(2),
    };

    try {
        const response = await axios.post(`${surl}/orders`, orderData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 201 || response.status === 200) {
            setTicket(response.data.order.ticket); // Show ticket number in modal
            setShowModal(true);
            setBasket([]); // Clear the basket after placing the order
        } else {
            console.error('Order failed:', response.data.message);
        }
    } catch (error) {
        console.error('Error placing order:', error);
    }
};


  const handleCancelOrder = () => {
    setBasket([]);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTicket(null);
    setBasket([]);
  };

  const fetchPosData = async (pid, tid) => {
    try {
      const response = await axios.get(`${surl}/pos`, {
        params: { p: pid, t: tid },
      });

      const categoriesData = response.data;
      if (Array.isArray(categoriesData) && categoriesData.length > 0) {
        setCategoriesWithProducts(categoriesData);
        setSelectedCategory(categoriesData[0]?.category?._id || null);
        setFilteredProducts(categoriesData[0]?.products || []);
      } else {
        console.error('No categories found or invalid response format');
      }
    } catch (error) {
      console.error('Error fetching POS data:', error);
    }
  };

  const handleCategoryChange = categoryId => {
    setSelectedCategory(categoryId);
    const selectedCategoryData = categoriesWithProducts.find(
      ({ category }) => category._id === categoryId
    );
    if (selectedCategoryData) {
      setFilteredProducts([...selectedCategoryData.products]);
    } else {
      setFilteredProducts([]);
    }
  };

  const handleAddToBasket = product => {
    const existingItem = basket.find(item => item.product._id === product._id);
    if (existingItem) {
      setBasket(
        basket.map(item =>
          item.product._id === product._id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      setBasket([...basket, { product, quantity: 1 }]);
    }
  };

  const handleRemoveFromBasket = product => {
    const existingItem = basket.find(item => item.product._id === product._id);
    if (existingItem) {
      if (existingItem.quantity > 1) {
        setBasket(
          basket.map(item =>
            item.product._id === product._id
              ? { ...item, quantity: item.quantity - 1 }
              : item
          )
        );
      } else {
        setBasket(basket.filter(item => item.product._id !== product._id));
      }
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pid = queryParams.get('p');
    const tid = queryParams.get('t');

    if (pid && tid) {
      fetchPosData(pid, tid);
      settID(tid);
      setpID(pid);
    }
  }, [location]);

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-900 text-white">
      <div
        className="lg:w-3/4 w-full p-4 bg-gray-800 overflow-y-auto"
        style={{
          backgroundImage: `url("${surl}/uploads/pozadina3.avif")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="flex space-x-4 overflow-x-auto mb-4 px-2 lg:px-6">
          {categoriesWithProducts.map(({ category }) => (
            <div key={category._id} className="flex flex-col items-center">
              <button
                onClick={() => handleCategoryChange(category._id)}
                className={`flex justify-center items-center w-16 h-16 md:w-20 md:h-20 rounded-full transition-transform transform hover:scale-105 border-4 ${
                  selectedCategory === category._id
                    ? 'border-red-500'
                    : 'border-white'
                } `}
                style={{ margin: '0.5rem' }}
              >
                {category.image ? (
                  <img
                    src={`${surl}${category.image}`}
                    alt={category.name}
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-400 rounded-full flex items-center justify-center text-sm">
                    No Image
                  </div>
                )}
              </button>
              <span className="text-xs mt-2">{category.name}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filteredProducts.map(product => (
            <div
              key={product._id}
              className="bg-gray-700 rounded-lg shadow-lg transition hover:bg-gray-600 p-2 flex flex-col"
            >
              {product.image ? (
                <img
                  src={`${surl}${product.image}`}
                  alt={product.name}
                  className="w-full h-32 md:h-40 object-cover rounded-t-lg"
                />
              ) : (
                <div className="w-full h-32 md:h-40 bg-gray-400 rounded-t-lg flex items-center justify-center text-sm text-gray-800">
                  No Image Available
                </div>
              )}
              <div className="p-2">
                <h3 className="text-lg font-bold">{product.name}</h3>
                <p className="text-gray-400 text-sm">{product.description}</p>
                <p className="text-yellow-400 font-semibold mt-1">
                  {product.price} kr
                </p>
                <div className="flex justify-between items-center mt-2">
                  <button
                    onClick={() => handleRemoveFromBasket(product)}
                    className="bg-gray-500 text-white px-3 py-1 rounded-full hover:bg-gray-600 transition text-sm"
                  >
                    -
                  </button>
                  <span className="text-lg font-semibold">
                    {
                      basket.find(item => item.product._id === product._id)
                        ?.quantity || 0
                    }
                  </span>
                  <button
                    onClick={() => handleAddToBasket(product)}
                    className="bg-gray-500 text-white px-3 py-1 rounded-full hover:bg-gray-600 transition text-sm"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className="lg:w-1/4 w-full p-4 bg-white text-black font-mono border-t lg:border-l lg:border-t-0 border-gray-400 shadow-lg rounded-t-lg lg:rounded-l-lg"
        style={{
          backgroundImage: `url("${surl}/uploads/paper.jpg")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <h2 className="font-bold mb-2 text-center text-gray-800">RECEIPT</h2>
        <div className="border-t border-dashed border-gray-500" />
        <div className="flex justify-between text-xs mt-2">
          <div>Terminal: {tid}</div>
          <div>{getCurrentTimeAndDate()}</div>
        </div>
        <div className="border-t border-dashed border-gray-500 my-2" />

        {basket.map(item => (
          <div key={item.product._id} className="mb-4">
            <div className="flex justify-between text-sm">
              <span>
                x{item.quantity} {item.product.name}
              </span>
              <span>
                {(item.product.price * item.quantity).toFixed(2)} kr
              </span>
            </div>
          </div>
        ))}

        <div className="mt-4 border-t border-dashed border-gray-500 pt-2">
          <h3 className="text-sm text-right font-bold">
            Total:{' '}
            {basket
              .reduce(
                (total, item) => total + item.product.price * item.quantity,
                0
              )
              .toFixed(2)}{' '}
            kr
          </h3>
          <div className="flex space-x-2 mt-4">
            <button
              className={`bg-green-600 px-4 py-2 w-full hover:bg-green-700 transition ${
                basket.length === 0 ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={handlePlaceOrder}
              disabled={basket.length === 0}
            >
              Place Order
            </button>
            <button
              className="bg-red-600 px-4 py-2 w-full hover:bg-red-700 transition"
              onClick={handleCancelOrder}
            >
              Cancel Order
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="fixed inset-0 bg-green-700 bg-opacity-90 flex items-center justify-center cursor-pointer"
          onClick={handleCloseModal}
        >
          <div className="text-white text-center p-8 rounded-lg">
            <h2 className="text-3xl font-bold mb-4">Ticket Number</h2>
            {ticket ? (
              <p className="text-6xl font-extrabold">{ticket}</p>
            ) : (
              <p className="text-2xl font-extrabold">No ticket available</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default POS;
